import { render, staticRenderFns } from "./add_new_post_config.vue?vue&type=template&id=48df2474&"
import script from "./add_new_post_config.vue?vue&type=script&lang=js&"
export * from "./add_new_post_config.vue?vue&type=script&lang=js&"
import style0 from "./add_new_post_config.vue?vue&type=style&index=0&id=48df2474&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports